import { combineReducers } from 'redux';
import banner from './banner';

const rootReducer = combineReducers({
  banner,
});

export default rootReducer;
